export function formatDateTime(value) {
  const s = String(value || '').trim()
  if (!s) return '-'
  return s.replace('T', ' ')
}
